export default {
  avatarShape: {
    square: 'Square',
    round: 'Round',
    roundedCorners: 'Rounded corners'
  },
  fontSize: {
    small: 'Small',
    medium: 'Medium',
    large: 'Large'
  },
  jobSeparator: {
    slash: '/',
    divide: '|',
    at: 'at',
    newLine: 'New line'
  },
  type: {
    email: 'Email',
    link: 'Link',
    text: 'Text'
  }
};
